import axios from "axios";

const state = {
    licenses: [],
    hosts: [],

	license: {},
	licenseInfo: {},
};

const actions = {
    async loadLicenses(context){
        return axios.get("/api/licenses").then(function(response){
			context.commit("setLicenses", response.data.licenses);
            context.commit("setHosts", response.data.hosts);
        })
    },
	async loadLicenseInfo(context, license) {
		return axios.get("/api/license/product/name",{params:{license:license}}).then(function(response){
			console.log(response)
			context.commit("setLicenseInfo", response.data);
		})
 	},
	async loadLicense(context,license){
		return axios.get("/api/license/invoice",{params:{license:license}}).then(function(response){
			context.commit("setLicense", response.data);
		})
	}
}

const mutations = {
    setLicenses(state,data){
        state.licenses = data;
    },

	setLicenseInfo(state,data) {
		state.licenseInfo = data;
	},

    setHosts(state,data){
        state.hosts = data;
    },

	setLicense(state,data){
		state.license = data;
	}
}

const getters = {
    licenses(state){
        return state.licenses;
    },
    hosts(state){
        return state.hosts;
    },
	license(state){
		return state.license
	},
	licenseInfo(state){
		return state.licenseInfo;
	}
};

export default {
    state,
    actions,
    mutations,
    getters
};
